import { Directive, ElementRef, inject, input } from '@angular/core';
import type { CtaLocation } from '../models/analytics.model';
import type { BillingTerm } from '../models/pricing.model';
import { AnalyticsService } from '../services/analytics.service';

/**
 * Reports a click on the link it sits on, through the analytics facade. The owning
 * template names the CTA and where it sits; the link's own href decides the event.
 */
@Directive({
  selector: 'a[avTrackCta]',
  host: { '(click)': 'reportClick()' },
})
export class TrackCtaDirective {
  private readonly analytics = inject(AnalyticsService);
  private readonly element = inject<ElementRef<HTMLAnchorElement>>(ElementRef);

  /** The CTA's `id`; an empty one reports nothing. */
  readonly avTrackCta = input.required<string | undefined>();
  readonly ctaLocation = input.required<CtaLocation | undefined>();
  readonly ctaPlan = input<string>();
  readonly ctaTerm = input<BillingTerm>();

  protected reportClick(): void {
    const id = this.avTrackCta();
    const location = this.ctaLocation();
    if (!id || !location) return;

    this.analytics.ctaClicked({
      id,
      location,
      href: this.element.nativeElement.getAttribute('href') ?? '',
      planCode: this.ctaPlan(),
      billingTerm: this.ctaTerm(),
    });
  }
}
